import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Open from "../../assets/images/Open.png";
import InProgress from "../../assets/images/In-Progress.png";
import Closed from "../../assets/images/closed.png";
import { Card } from "../common/GlobalElements/Card";
import { BodySmall, BodyText, Heading5 } from "../common/GlobalElements/Typography";

export default function ExamSummeryList(props) {
  const [exam, setExam] = useState([]);

  useEffect(() => {
    setExam(props.exam);
  }, []);

  return (
    <>
      {Object.keys(exam).length ? (
        <li title={exam.period} key={exam.exam_id} className="exam-card">

          <Link
            to={`/myexamdetails/${exam.exam_id}`}
            className="exam-link-redirect"
          >
            <Card gap={"12px"}>

              <div className="icon">EP</div>
              <Heading5 className="text-primary">
                Exam Period
                <br /> {exam.period}
              </Heading5>
              <BodySmall>
                <i className="">
                  <img src={exam.registrationStatus == "OPEN" ? Open : Closed} />
                </i>

                {exam.registrationStatus}
              </BodySmall>
              <BodySmall
                className={
                  exam.registrationStudentStatus == "Not Registered"
                    ? "colorRed"
                    : "colorGreen"
                }
              >
                <i className={exam.registrationStudentIcon}></i>
                {exam.registrationStudentStatus}
              </BodySmall>
              <BodySmall>
                <i className="fal fa-calendar-days"></i>
                {`${exam.startPriodTime} to ${exam.endPriodTime}`}
              </BodySmall>
              <BodySmall>
                <i className="">
                  <img
                    src={
                      exam.exam_status_text == "IN PROGRESS" ? InProgress : Closed
                    }
                    alt="in-progress-icon"
                  />
                </i>
                {exam.exam_status_text == "IN PROGRESS"
                  ? "EXAM IN PROGRESS"
                  : "EXAM CLOSED"}
              </BodySmall>
            </Card>
          </Link>
        </li>
      ) : null}
    </>
  );
}
